// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Mq8Wr_8TIYchDYAu_MoT {
  padding: 30px 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.83;
  text-align: center;
  flex-direction: column;
  flex-wrap: wrap;
  color: var(--xds-color-charcoal-70);
  font-size: var(--xds-font-size-12);
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer/style.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,mCAAmC;EACnC,kCAAkC;AACpC","sourcesContent":[".footer {\n  padding: 30px 35px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1.83;\n  text-align: center;\n  flex-direction: column;\n  flex-wrap: wrap;\n  color: var(--xds-color-charcoal-70);\n  font-size: var(--xds-font-size-12);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Mq8Wr_8TIYchDYAu_MoT`
};
export default ___CSS_LOADER_EXPORT___;
